import { Container } from "../../Utils/Container/Container";
import { Header } from "../../components/Header/Header";
import PickDate from "../../components/PickDate/PickDate";
import { Calendar } from "../../components/Calendar/Calendar";
import { Cards } from "../../components/Cards/Cards";
import { FilledCards } from "../../components/FilledCards/FilledCards";
import AnswerTo from "../../components/AnswerTo/AnswerTo";
import SubmitButton from "../../components/SubmitButton/SubmitButton";

const MainPage = () => {
	return (
		<Container>
				<Header />
				<div className="wrapper">
					<div className="left-content">
						<div>
							<PickDate />
						</div>
						<div>
							<Calendar />
						</div>
					</div>
					<div className="right-content">
						<FilledCards />
						<Cards />
						<AnswerTo />
						<SubmitButton />
					</div>
				</div>
			</Container>
	)
}

export default MainPage;
